






import { defineComponent, onMounted } from '@vue/composition-api';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';

export default defineComponent({
  name: 'HaiXiaoBar',
  setup() {
    // 曝光埋点
    onMounted(() => {
      ubtSetupModuleExpose('finance_loan_home_BrandShow', {});
    });
  },
});
